module.exports = __webpack_public_path__ + "static/media/empty_photo.546fb4a5.png";